import alertMiddleware from '../middleware/alert'
import apiMiddleware from '../middleware/api'
import { createLogger } from 'redux-logger'
import history from '../routes/history'
import locationMiddleware from '../middleware/location'
import rootReducer from '../reducers/index'
import thunk from 'redux-thunk'
import { routerMiddleware } from 'react-router-redux'
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'

let middlewares = [
  thunk,
  apiMiddleware,
  alertMiddleware,
  locationMiddleware,
  routerMiddleware(history)
]

if (process.env.NODE_ENV !== 'production') {
  middlewares = [
    ...middlewares,
    createLogger({
      collapsed: true,
      duration: true,
      timestamp: false
    })
  ]
}

export default function configureStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middlewares))
  )
}



// WEBPACK FOOTER //
// ../src/store/configureStore.js